/**
 * Main Menu
 */
;(function ($) {
	$('.menu__toggle').on('click', function (e) {
		e.preventDefault()
		var $this = $(this)
		var panel = $('.menu__panel')
		var expandend = $this.attr('aria-expanded') === 'false' ? 'true' : 'false'
		var hidden = panel.attr('aria-hidden') === 'false' ? 'true' : 'false'
		$('body').toggleClass('menu-main-open')
		panel.toggleClass('open')
		$this.attr('aria-expanded', expandend)
		panel.attr('aria-expanded', expandend)
		panel.attr('aria-hidden', hidden)
	})
})(jQuery)
